export default {
  namespaced: true,

  state: {
    tickets: [],
    orderRedeliveryRequests: [],
    priceChangeRequests: [],
    loading: false,
  },

  getters: {
    tickets: state => state.tickets,
    orderRedeliveryRequests: state => state.orderRedeliveryRequests,
    priceChangeRequests: state => state.priceChangeRequests,
    loading: state => state.loading,
  },

  mutations: {
    SET_TICKETS(state, tickets) {
      state.tickets = tickets
    },

    SET_ORDER_REDELIVERY_REQUESTS(state, requests) {
      state.orderRedeliveryRequests = requests
    },

    SET_PRICE_CHANGE_REQUESTS(state, requests) {
      state.priceChangeRequests = requests
    },

    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },

  actions: {
    async fetchDriverTickets({ commit }, { queryParams = {} } = {}) {
      commit('SET_LOADING', true)

      try {
        const response = await this.$http.get('/api/support/driver-tickets/', {
          params: queryParams,
        })

        return response
      } catch (error) {
        console.error('Error fetching driver tickets:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchDriverTicketStatistics() {
      try {
        // Mock statistics for now - replace with actual API call
        const statistics = {
          total: 0,
          new: 0,
          in_progress: 0,
          resolved: 0,
          closed: 0,
          escalated: 0,
        }

        return { data: statistics }
      } catch (error) {
        console.error('Error fetching driver ticket statistics:', error)
        throw error
      }
    },

    async updateDriverTicket(context, { id, data }) {
      try {
        const response = await this.$http.patch(`/api/support/driver-tickets/${id}/`, data)
        return response
      } catch (error) {
        console.error('Error updating driver ticket:', error)
        throw error
      }
    },

    async addDriverTicketContactAttempt(context, { id }) {
      try {
        const response = await this.$http.post(`/api/support/driver-tickets/${id}/add_contact_attempt/`)
        return response
      } catch (error) {
        console.error('Error adding contact attempt:', error)
        throw error
      }
    },
  },
}
